export default __webpack_public_path__ + "6040a6c0ad10ecb1c3a52f2b3477568d.png";